<template>
    <section class="ath-row dashboard-item-config-expanded">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 sp-m b-r item-config-column">
            <DashboardConfigurationTabs :sections="allowedSections"
                :selectedSection="hasSelectedSection ? selected_section.section : ''"
                :config="internal_config"
                @onSelect="selectSection" />
        </div>
        <!-- MultiConfigDisplay version to show multiple configuration components -->
        <div v-if="isMultiSection"
            class="col-xs-8 col-sm-8 col-md-8 col-lg-8 sp-m item-config-column">
            <MultiConfigDisplay :lbl="selected_section.section_label"
                :children="selected_section.config_children"
                :config="internal_config"
                :sideBySideMode="true"
                :editMode="false"
                :dashboardType="dashboardType"
                :dashboard="dashboard"
                :widgetType="widgetType"
                :isV2MultiSection="isV2MultiSection"
                @onUpdate="onUpdate" />
        </div>
        <!-- Section has a componnet key. This is being deprecated -->
        <div v-else-if="hasComponentKey"
            class="col-xs-8 col-sm-8 col-md-8 col-lg-8 sp-m item-config-column">
            <comp :config="internal_config"
                v-bind="selected_section.config"
                :is="sectionComponent"
                :sideBySideMode="true"
                :dashboardType="dashboardType"
                :dashboard="dashboard"
                :widgetType="widgetType"
                @onUpdate="onUpdate" />
        </div>
    </section>
</template>

<script>
import { isNeArray } from '@aretheyhappy/utils';
import DashboardConfigurationControllerMixin from '../mixins/DashboardConfigurationControllerMixin';

/**
 * This component is meant to be almost the exact same as DashboardItemConfig.vue
 * with the only differece being that the components are shown to the right of the sections
 * instead of swapping them out.
 *
 * This component and DashboardItemConfig.vue should be kept in sync.
 */
export default {
    mixins: [DashboardConfigurationControllerMixin],
    created: function () {
        this.is_edit_mode = false;
        this.emit_invalid_configs = false;
        // Select first section on load
        if (isNeArray(this.allowedSections))
            this.selectSection(this.allowedSections[0]);
    }
};
</script>
<style lang="scss" scoped>
@use '../../../../../sass/variables' as *;
.dashboard-item-config-expanded {
    width: 60rem;
    background-color: var(--c-page-bg);
    // Ath-row has negative margins, pushing this out of popovers
    margin: 0;
    border-radius: 0 0 1rem 1rem;
}

.item-config-column {
    max-height: 35rem;
    overflow: auto;
}
</style>